import { Inbox } from "lucide-react";

/** Clean empty state for any list, tab, or search-no-results screen. */
export default function EmptyState({
  icon: Icon = Inbox,
  title = "Nothing here yet",
  caption,
  action,
  testId = "empty-state",
}) {
  return (
    <div data-testid={testId} className="text-center py-12 px-6">
      <Icon className="w-10 h-10 text-brand-muted mx-auto mb-3" strokeWidth={1.25} />
      <div className="font-serif text-lg text-brand-ink mb-1">{title}</div>
      {caption && <div className="text-sm text-brand-muted mb-4">{caption}</div>}
      {action}
    </div>
  );
}
